/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reject Clubhouse Reservation Request Schema
 * @export
 * @interface RejectClubhouseReservationRequestRequest
 */
export interface RejectClubhouseReservationRequestRequest {
    /**
     * Response
     * @type {string}
     * @memberof RejectClubhouseReservationRequestRequest
     */
    response: string;
}

/**
 * Check if a given object implements the RejectClubhouseReservationRequestRequest interface.
 */
export function instanceOfRejectClubhouseReservationRequestRequest(value: object): value is RejectClubhouseReservationRequestRequest {
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function RejectClubhouseReservationRequestRequestFromJSON(json: any): RejectClubhouseReservationRequestRequest {
    return RejectClubhouseReservationRequestRequestFromJSONTyped(json, false);
}

export function RejectClubhouseReservationRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectClubhouseReservationRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'response': json['response'],
    };
}

export function RejectClubhouseReservationRequestRequestToJSON(value?: RejectClubhouseReservationRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'response': value['response'],
    };
}

